import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  buttonStyle: { marginHorizontal: scale(16) },
});
export default styles;
